import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CookieServiceService } from '../cookie-service.service';
import { HelperService } from '../helper.service';
import { UtilisService } from '../utilis.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public helperService: HelperService, private router: Router, private ngZone: NgZone,
    private utilService: UtilisService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private cookieService: CookieServiceService, private route: ActivatedRoute) {

  }
  account_number: any = "";
  isVisible: boolean = false;
  OTPresponseVisible: boolean = false;
  OTPresponse: any = "";
  txtcaptcha: any;
  captchaimg: any;
  imagettag: any;
  captcha_hash: any;
  uuid: any;
  phone_no: any;
  IssueArr1: any = [];
  isDisabled: Boolean = true;
  GETOTP() {
    try {
      this.IssueArr1 = ({
        captcha_text: this.utilService.EncryptdataV1(this.txtcaptcha, this.utilService.getData()),
        hash: this.utilService.EncryptdataV1(this.captcha_hash, this.utilService.getData()),
        account_no: this.utilService.EncryptdataV1(this.account_number, this.utilService.getData()),
        key: this.utilService.getData()
      })
      this.spinner.show();
      this.helperService.makePostRequest(this.IssueArr1, "/getOTP").subscribe(res => {
        this.spinner.hide();
        if (this.utilService.DecryptdataV1(res.status,this.utilService.getData()).trim() === "FCAP") {
          this.isVisible = true;
          this.getKey();
          this.captchatoimage();
        }
        else {
          if (this.utilService.DecryptdataV1(res.status, this.utilService.getData()) === "S"
            && this.utilService.DecryptdataV1(res.uuid, this.utilService.getData()) !== "Nil") {
            this.toast.success(this.utilService.DecryptdataV1(res.msg,this.utilService.getData()), "", {
              positionClass: 'toast-top-right'
            });
            this.uuid = this.utilService.DecryptdataV1(res.uuid,this.utilService.getData());
            this.phone_no = this.utilService.DecryptdataV1(res.phone,this.utilService.getData());
            this.ngZone.run(() => this.router.navigateByUrl('/OTPValidate',
              { state: { uuid: this.uuid, phone_no: this.phone_no } }));
          }
          else {
            this.getKey();
            this.captchatoimage();
            this.account_number = "";
            this.txtcaptcha = "";
            this.OTPresponseVisible = true;
            this.OTPresponse = this.utilService.DecryptdataV1(res.msg, this.utilService.getData());
          }
        }
        (err) => {
          if (err.status == 401) {
            this.spinner.hide();
            this.toast.error('', "Some Error Occured");
            this.cookieService.clearTokenCookie();
          }
        }
      });
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Some error occured", "", {
        positionClass: 'toast-bottom-right'
      });
    }
  }
  captchatoimage() {
    this.txtcaptcha = "";
    this.account_number = "";
    try {
      this.txtcaptcha = "";
      this.helperService.makeGetRequest("/Captcha").subscribe(res => {
        this.captcha_hash = res.hash;
        this.captchaimg = 'data:image/jpeg;base64,' + res.img;
      });
      //this.captchaimg = 'data:image/jpeg;base64,' + this.base64test;
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Unable To Load Captcha. Please contact Administrator", "", {
        positionClass: 'toast-bottom-right'
      });
    }
  }

  getKey() {
    try {
      this.txtcaptcha = "";
      this.helperService.makeGetRequest("/getKey").subscribe(res => {
        this.utilService.setData(res.enc_key);
      });
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Unable To Load Captcha. Please contact Administrator", "", {
        positionClass: 'toast-bottom-right'
      });
    }
  }

  ngOnInit(): void {
    this.txtcaptcha = "";
    this.account_number = "";
    this.getKey();
    this.captchatoimage();
  }
  disableGenerateButton() {
    this.account_number = (this.account_number ? this.account_number + "" : "");
    this.txtcaptcha = (this.txtcaptcha ? this.txtcaptcha + "" : "");
    if (this.account_number && this.account_number.length > 0 && this.account_number.length === 14
      && this.txtcaptcha && this.txtcaptcha.length > 0 && this.txtcaptcha.length === 5) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

}

